// extracted by mini-css-extract-plugin
export default {"admin-options":"AdminOptions_admin-options__+Hnlx","admin-button-white":"AdminOptions_admin-button-white__Ro6iN","admin-button-red":"AdminOptions_admin-button-red__mAMO3"};